import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, shareReplay, tap } from "rxjs/operators";

import { CONSOLIDATED_FEED_DEFAULT_CHECKOUT_MOV_CENTS } from "../../core/components/product-list/product-list.constants";
import { DataService } from "../../core/providers/data/data.service";
import { GET_STOREFRONT_CONSOLIDATED_FEED } from "../graphql/consolidated-feed.graphql";
import { resolveConsolidatedFeedCheckoutMovCents } from "../utils/consolidated-feed-cart";

@Injectable({
    providedIn: "root",
})
export class ConsolidatedFeedStorefrontService {
    private checkoutMovCents: number = CONSOLIDATED_FEED_DEFAULT_CHECKOUT_MOV_CENTS;
    private load$: Observable<number> | null = null;

    constructor(private dataService: DataService) {}

    ensureLoaded(): Observable<number> {
        if (!this.load$) {
            this.load$ = this.dataService
                .query<{
                    storefrontConsolidatedFeed?: {
                        customerMov?: number | null;
                    } | null;
                }>(GET_STOREFRONT_CONSOLIDATED_FEED)
                .pipe(
                    map(({ storefrontConsolidatedFeed }) =>
                        resolveConsolidatedFeedCheckoutMovCents(
                            storefrontConsolidatedFeed?.customerMov,
                        ),
                    ),
                    tap((movCents) => {
                        this.checkoutMovCents = movCents;
                    }),
                    shareReplay(1),
                );
        }
        return this.load$;
    }

    getCheckoutMovCents(): number {
        return this.checkoutMovCents;
    }

    setCheckoutMovCents(customerMovCents?: number | null): void {
        this.checkoutMovCents =
            resolveConsolidatedFeedCheckoutMovCents(customerMovCents);
    }
}
